import React from "react";
import { ExternalLink, Handshake } from "lucide-react";

const MSA_URL = "https://www.montanaskatepark.org/";

const MSA_BODY =
    "The Seeley Lake Skatepark Association is proud to partner with the Montana Skatepark Association, a statewide nonprofit with decades of experience helping Montana communities build free, public concrete skateparks. MSA provides trusted guidance, fundraising support, and project expertise as we work to bring a community-built skatepark to Seeley Lake.";

// Reusable MSA partner banner. `label` controls the small eyebrow tag
// ("Our Partner" on Sponsors, "Fiscal Sponsor" on About).
export const MSABanner = ({ label = "Our Partner" }) => (
    <section className="py-16 px-4 bg-[#2D5A27]" data-testid="msa-banner">
        <div className="max-w-7xl mx-auto">
            <div className="mb-8">
                <span className="font-marker text-[#C9A84C] text-2xl -rotate-1 inline-block mb-2">{label}</span>
                <h2 className="font-anton text-3xl sm:text-5xl text-[#F5EDD6] uppercase leading-none">
                    Proudly Partnering with Montana Skatepark Association
                </h2>
            </div>
            <div className="bg-[#F5EDD6] border-4 border-[#C9A84C] p-8 sm:p-10 shadow-[8px_8px_0px_0px_rgba(201,168,76,0.4)]">
                <div className="flex flex-col lg:flex-row lg:items-center gap-8">
                    <div className="flex-1">
                        <div className="flex items-center gap-3 mb-4">
                            <Handshake size={22} className="text-[#2D5A27]" />
                            <span className="font-manrope text-xs font-bold text-[#2D5A27] uppercase tracking-widest">
                                Montana Skatepark Association
                            </span>
                        </div>
                        <p className="font-manrope text-[#3D2008] text-base sm:text-lg leading-relaxed">
                            {MSA_BODY}
                        </p>
                    </div>
                    <div className="lg:flex-shrink-0">
                        <a
                            href={MSA_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="msa-learn-more-btn"
                            className="inline-flex items-center gap-2 whitespace-nowrap px-7 py-4 bg-[#2D5A27] text-[#F5EDD6] font-anton uppercase tracking-wider text-base border-2 border-[#3D2008] shadow-[4px_4px_0px_0px_#3D2008] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-transform duration-150"
                        >
                            Learn More About MSA <ExternalLink size={15} />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default MSABanner;
